module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-starts-3-large-ee10006a963509bb65501d397ec4d34a.jpg";